export const hasIFrame = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('iframe') === 'true';
};
